import { render, staticRenderFns } from "./advanced-settings.vue?vue&type=template&id=3d11a72c&"
import script from "./advanced-settings.vue?vue&type=script&lang=js&"
export * from "./advanced-settings.vue?vue&type=script&lang=js&"
import style0 from "./advanced-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d11a72c')) {
      api.createRecord('3d11a72c', component.options)
    } else {
      api.reload('3d11a72c', component.options)
    }
    module.hot.accept("./advanced-settings.vue?vue&type=template&id=3d11a72c&", function () {
      api.rerender('3d11a72c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/advanced-settings.vue"
export default component.exports